import LineChart from './LineGraph'
import AreaChart from './AreaRealtimeGraph'
import CombineChart from './CombineGraph'

export default { LineChart, AreaChart, CombineChart }
